// Envoltorio delgado de DOMPurify para desinfectar HTML rico proveniente del editor Tiptap
// (documentos, cartas, plantillas de liquidación). Impide XSS al bloquear <script>, event
// handlers (onclick, onerror, ...), javascript: URIs, y otros vectores.
//
// Uso:
//   import { sanitizeHtml } from "@/lib/sanitize";
//   const clean = sanitizeHtml(dirty);
//
// Config: permitimos todo el HTML semántico + estilos inline (para tablas de liquidación
// que se pintan con inline styles al pasar por html2canvas), pero prohibimos scripts y
// atributos de eventos.

import DOMPurify from "dompurify";

const CONFIG = {
  USE_PROFILES: { html: true },
  ADD_ATTR: ["style", "colspan", "rowspan", "target"],
  FORBID_TAGS: ["script", "style", "iframe", "object", "embed"],
  FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover", "onfocus", "onblur", "onchange", "onsubmit"],
};

export function sanitizeHtml(html) {
  if (html == null) return "";
  return DOMPurify.sanitize(String(html), CONFIG);
}
